import React from 'react';
import { Icon } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import CopyIcon from '@/components/CopyIcon';
import { tokenStatus } from '../constants';

const TokenIcon = ({ active, jwt }) => {
  const intl = useIntl();
  if (active && jwt) {
    return (<CopyIcon text={jwt} messageId="token.copy" />);
  }

  return (
    <Icon
      name={active ? 'code' : 'wait'}
      className={active ? 'primary' : 'disabled'}
      title={intl.formatMessage({ id: `status.${active ? tokenStatus.ACTIVE : tokenStatus.EXPIRED}` })}
    />
  );
};

export default TokenIcon;
